export const normalizeEmail = (value) => {
  if (!value) return value;
  return value.trim().toLowerCase();
};

/**
 * Normalizes to E.164 (e.g. "+14076548727") using a digit-count heuristic
 * (no phone-parsing library on web): 10 digits assumes US and adds "+1",
 * 11 digits starting with "1" gets a "+", anything else is passed through
 * digits-only with a "+" prefix so callers never have to type it themselves.
 */
export const normalizePhone = (value) => {
  if (!value) return value;
  const digits = value.replace(/\D/g, "");
  if (!digits) return value;
  if (digits.length === 10) return `+1${digits}`;
  if (digits.length === 11 && digits.startsWith("1")) return `+${digits}`;
  return `+${digits}`;
};



// WEBPACK FOOTER //
// ./src/common/normalize.js